import { render, staticRenderFns } from "./bulk-update-view.vue?vue&type=template&id=2ebe76a0&scoped=true"
import script from "./bulk-update-view.vue?vue&type=script&lang=js"
export * from "./bulk-update-view.vue?vue&type=script&lang=js"
import style0 from "./bulk-update-view.vue?vue&type=style&index=0&id=2ebe76a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebe76a0",
  null
  
)

export default component.exports